module.exports = __webpack_public_path__ + "static/img/success-head.955be75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success-head.png
// module id = PyX3
// module chunks = 1